import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormat'
})
export class CurrencyFormatPipe implements PipeTransform {

  transform(value: number | string, ...args: unknown[]): string {
    if (value == null) return '';

    // Convertir el valor a número
    let numValue = typeof value === 'string' ? parseFloat(value) : value;
    
    // Formatear el número con separadores de miles y decimales
    return numValue.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

}